import loginService from '../domain/services/login.service';

const filterChildrenByRoles = (children, currentUser) =>
    children.filter((child) => !child.roles || loginService.isValidRoles(child.roles, currentUser));

const flattenToSingleChild = (category, child) =>
    ({ ...child, icon: child.icon || category.icon });

export const buildMenuCategory = (category, currentUser) => {

    const children = filterChildrenByRoles(category.children, currentUser);

    const shouldFlatten = category.isFlat && children.length === 1;
    if (shouldFlatten)
        return flattenToSingleChild(category, children[0]);

    return { ...category, children };
};
